function removeFacebookCookieHint() {
    const facebookCookieHint = document.getElementById('fb-messenger-cookie');
    if (facebookCookieHint.parentNode) {
        facebookCookieHint.parentNode.removeChild(facebookCookieHint);
    }
}

function loadFacebookMessengerSkript() {

    var js, fjs = document.getElementsByTagName('script')[0];
    if (document.getElementById('facebook-jssdk')) return;
    js = document.createElement('script'); js.id = 'facebook-jssdk';
    js.src = 'https://connect.facebook.net/de_DE/sdk/xfbml.customerchat.js#xfbml=1&version=v2.12&autoLogAppEvents=1';
    fjs.parentNode.insertBefore(js, fjs);
}

function facebookMessengerIsEnabled() {
    const allCookies = `; ${document.cookie}`;
    const parts = allCookies.split(`; ${'facebookMessenger'}=`);

    if (parts.length === 2) {
        const enabled = parts.pop().split(';').shift();
        return !!enabled;
    }
}

function setFacebookMessengerCookie(expiresInDays = 1, domain = null) {
    const expiresDate = new Date();
    expiresDate.setTime(expiresDate.getTime() + (expiresInDays * 365 * 24 * 60 * 60 * 1000));
    const expiresString = `expires=${expiresDate.toUTCString()};`;
    const domainString = domain ? `domain=${domain};` : '';

    document.cookie = `${'facebookMessenger'}=${'true'};${expiresString};${domainString};path=/`;
}

document.addEventListener('DOMContentLoaded', () => {
    if (facebookMessengerIsEnabled()) {
        removeFacebookCookieHint();
        loadFacebookMessengerSkript();
        return;
    }

    if (document.getElementById('fb-messenger-opt-in')) {
        document.getElementById('fb-messenger-opt-in').onclick = () => {
            const messenger = document.getElementById('fb-messenger-chat-window');

            if (messenger.classList.contains('invisible')) {
                messenger.classList.add('visible');
                messenger.classList.remove('invisible');
                messenger.style.visibility = "visible";
            } else {
                messenger.classList.add('invisible');
                messenger.classList.remove('visible');
                messenger.style.visibility = "hidden";
            }
        }
    }

    if (document.getElementById('fb-messenger-accept')) {
        document.getElementById('fb-messenger-accept').onclick = () => {
            setFacebookMessengerCookie();
            removeFacebookCookieHint()
            loadFacebookMessengerSkript();
        }
    }
});
